import { ColDef } from "ag-grid-community";

import { CommentRenderer } from "lib/agGrid/renderers/commentRenderer";

export const CommentColId = {
  COMMENTS: "comments",
} as const;

interface CommentSummary {
  commentType: string;
  commentTypeId: string;
  resolvedCommentCount: number;
  unresolvedCommentCount: number;
}

interface CommentRow {
  // NB: `field` is intentionally left unset here - consumers spread this
  // column definition and set their own `field`/`valueGetter` pointing at
  // their own comment-summary shaped data.
  comments?: CommentSummary;
}

export const CommentColumnDef: Record<
  ValueInObj<typeof CommentColId>,
  ColDef<CommentRow>
> = {
  [CommentColId.COMMENTS]: {
    colId: CommentColId.COMMENTS,
    headerName: "Comments",
    cellRenderer: CommentRenderer,
    width: 100,
  },
};
